// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__x+it-","tableRow":"styles_tableRow__P68Ca","noData":"styles_noData__Eonba","dayName":"styles_dayName__Aqryx","theme":"styles_theme__knER8"};